import CoreInstance from '../CoreInstance';
import { isTeacher } from 'lib/helpers';
import { localeFlag, getHeadersWithTokens } from '../ApiHelpers';

interface ISubcriptions {
  getPremiumPlans?: any;
  createSubscription(body: any): any;
  getOutstandingDebt(id: number, locale?: string): any;
  getSubscriptions(): any;
  updateSubscription(id: number, payload: any): any;
  cancelSubscription(id: number): any;
  getPendingAmountDue(id: number, locale?: string): any;
  getPreviewUpdateSubscription(id: any, date: string, quantity: number, locale?: string): any;
}

const subscriptions: ISubcriptions = {
  getOutstandingDebt: (id: number, locale: string) => CoreInstance.get(`/organizations/subscriptions/${id}/pending_amount_due?${localeFlag(locale)}`),
  getSubscriptions: () => {
    const organizationToken = isTeacher() ? localStorage.getItem('active_center_token') : localStorage.getItem('account_token');
    const headers = {
      headers: {
        Authorization: `Bearer ${organizationToken}`,
      },
    };
    return CoreInstance.get(
      isTeacher()
        ? `/centers/subscription?${localeFlag()}`
        : `/organizations/subscriptions?${localeFlag()}`,
      headers,
    );
  },
  getPremiumPlans: () => CoreInstance.get(`/premium_plans?${localeFlag()}`),
  createSubscription: (body: any) => CoreInstance.post(`/organizations/subscriptions?${localeFlag()}`, body, getHeadersWithTokens()),
  updateSubscription: (id: number, payload: any) => CoreInstance.put(
    isTeacher()
      ? `/centers/subscriptions/${id}?${localeFlag()}`
      : `/organizations/subscriptions/${id}?${localeFlag()}`,
    payload,
    getHeadersWithTokens(),
  ),
  cancelSubscription: (id: number) => CoreInstance.put(`/organizations/subscriptions/${id}/cancel?${localeFlag()}`),
  getPendingAmountDue: (id: number, locale:string) => CoreInstance.get(`/organizations/subscriptions/${id}/pending_amount_due?${localeFlag(locale)}`),
  getPreviewUpdateSubscription: (id: any, date: string, quantity: number, locale: string) =>
    CoreInstance.get(
      isTeacher()
        ? `/centers/subscriptions/${id}/update_preview?proration_date=${date}&quantity=${quantity}&${localeFlag(locale)}`
        : `/organizations/subscriptions/${id}/update_preview?proration_date=${date}&quantity=${quantity}&${localeFlag(locale)}`,
      getHeadersWithTokens(),
    ),
};


export default {
  subscriptions,
};
